import { root, folder, today, yesterday } from './seed.js';
import { getFsMap, flattenTree } from './store.svelte.js';

function collect(predicate, node = root, out = []) {
  if (predicate(node)) out.push(node);
  for (const child of node.children ?? []) collect(predicate, child, out);
  return out;
}

function buildVirtualSearchNodes() {
  return [
    folder('Today', 'search://today', 'search-clock', collect((node) => node.modified === today && node.path !== 'search://today').slice(0, 12)),
    folder('Yesterday', 'search://yesterday', 'search-clock', collect((node) => node.modified === yesterday).slice(0, 12)),
    folder('Past Week', 'search://past-week', 'search-clock', collect((node) => [today, yesterday].includes(node.modified)).slice(0, 18)),
    folder('All Images', 'search://images', 'image-file', collect((node) => ['image-file', 'folder-pictures'].includes(node.icon)).slice(0, 12)),
    folder('All Movies', 'search://movies', 'movie-file', collect((node) => ['movie-file', 'folder-movies'].includes(node.icon)).slice(0, 12)),
    folder('All Documents', 'search://documents', 'document', collect((node) => ['document', 'resume', 'font-file', 'web-link'].includes(node.icon)).slice(0, 12)),
  ];
}

let virtualSearchNodes = buildVirtualSearchNodes();

function indexSearchNodes() {
  for (const node of virtualSearchNodes) flattenTree(node, getFsMap());
}

indexSearchNodes();

export { collect, buildVirtualSearchNodes, virtualSearchNodes, indexSearchNodes };
